/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 *
 * Source: github.com/qonto-private/clients-terms-and-conditions
 * Script: pnpm --filter @repo/shared-config fetch-terms-and-conditions
 */

export interface TermsAndConditionsLink {
  url: string;
  language?: string;
  country?: string;
}

export interface TermsAndConditionsEntry {
  type: 'language' | 'country';
  links: TermsAndConditionsLink[];
}

export const TERMS_AND_CONDITIONS = {
  'account-closing-terms': {
    type: 'language',
    links: [
      {
        language: 'fr',
        url: 'https://legal.qonto.com/fr#template-fbg-o29f5',
      },
      {
        language: 'it',
        url: 'https://legal.qonto.com/it#template-fbg-o29f5',
      },
    ],
  },
  accounts_remuneration: {
    type: 'country',
    links: [
      {
        country: 'FR',
        url: 'https://legal.qonto.com/#remunerated-account-2025-program-fr',
      },
      {
        country: 'ES',
        url: 'https://legal.qonto.com/#remunerated-account-2025-program-es',
      },
      {
        country: 'NL',
        url: 'https://legal.qonto.com/#remunerated-account-2025-program-nl',
      },
      {
        country: 'IT',
        url: 'https://legal.qonto.com/#remunerated-account-2025-program-it',
      },
    ],
  },
  'capital-deposit-terms': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://legal.qonto.com/en#template-k-joosxaw',
      },
      {
        language: 'fr',
        url: 'https://legal.qonto.com/fr#template-zgairaxx6',
      },
      {
        language: 'nl',
        url: 'https://legal.qonto.com/nl#template-k-joosxaw',
      },
    ],
  },
  'capital-increase-terms': {
    type: 'language',
    links: [
      {
        language: 'fr',
        url: 'https://legal.qonto.com/fr#template-cpvrfprcp',
      },
    ],
  },
  'cashback-terms': {
    type: 'country',
    links: [
      {
        country: 'FR',
        url: 'https://legal.qonto.com/#cashback-program-fr',
      },
      {
        country: 'IT',
        url: 'https://legal.qonto.com/#cashback-program-it',
      },
      {
        country: 'DE',
        url: 'https://legal.qonto.com/#cashback-program-de',
      },
      {
        country: 'ES',
        url: 'https://legal.qonto.com/#cashback-program-es',
      },
      {
        country: 'NL',
        url: 'https://legal.qonto.com/#cashback-program-nl',
      },
      {
        country: 'PT',
        url: 'https://legal.qonto.com/#cashback-program-pt',
      },
      {
        country: 'AT',
        url: 'https://legal.qonto.com/#cashback-program-at',
      },
      {
        country: 'BE',
        url: 'https://legal.qonto.com/#cashback-program-be',
      },
    ],
  },
  'credit-card-information-document': {
    type: 'country',
    links: [
      {
        country: 'IT',
        url: 'https://legal.qonto.com/it#foglio-informativo-ddc',
      },
      {
        country: 'ES',
        url: 'https://legal.qonto.com/es#folleto-informativo-ddc',
      },
    ],
  },
  'einvoicing-italy-terms': {
    type: 'language',
    links: [
      {
        language: 'it',
        url: 'https://legal.qonto.com/it#template-l-eapgcsu',
      },
    ],
  },
  'external-bank-account-consent': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://legal.qonto.com/#template-iucqxyxdg',
      },
      {
        language: 'fr',
        url: 'https://legal.qonto.com/#template-1bmikaf4h',
      },
      {
        language: 'de',
        url: 'https://legal.qonto.com/#template-vx1bopsja',
      },
      {
        language: 'it',
        url: 'https://legal.qonto.com/#template-dirmcbskb',
      },
      {
        language: 'es',
        url: 'https://legal.qonto.com/#template-pjgysdusr',
      },
    ],
  },
  'financial-tools': {
    type: 'country',
    links: [
      {
        country: 'ES',
        url: 'https://legal.qonto.com/es#folleto-informativo',
      },
      {
        country: 'IT',
        url: 'https://legal.qonto.com/it#template-c0iteozwa',
      },
    ],
  },
  'finutive-services-contract': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://legal.qonto.com/#template-a0zdipvia',
      },
    ],
  },
  'gen-ai-logo-terms': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://legal.qonto.com/#template-xzrxtdwqv',
      },
    ],
  },
  'insurance-hub-it-information-set': {
    type: 'country',
    links: [
      {
        country: 'IT',
        url: 'https://legal.qonto.com/#pre-contractual-information-insurance-hub-it',
      },
    ],
  },
  'insurance-hub-it-terms-aes': {
    type: 'country',
    links: [
      {
        country: 'IT',
        url: 'https://legal.qonto.com/#aes-insurance-hub-it',
      },
    ],
  },
  'insurance-hub-it-terms-distribution': {
    type: 'country',
    links: [
      {
        country: 'IT',
        url: 'https://legal.qonto.com/it#t-c-insurance-hub-it',
      },
    ],
  },
  'insurance-hub-pre-contractual-notice': {
    type: 'country',
    links: [
      {
        country: 'FR',
        language: 'fr',
        url: 'https://legal.qonto.com/#information-prealable-a-la-conclusion-d-un-contrat-d-assurance-fr',
      },
      {
        country: 'FR',
        language: 'en',
        url: 'https://legal.qonto.com/#pre-contractual-information-for-the-conclusion-of-an-insurance-contract-en',
      },
      {
        country: 'DE',
        language: 'de',
        url: 'https://legal.qonto.com/#erstinformation-de',
      },
      {
        country: 'DE',
        language: 'en',
        url: 'https://legal.qonto.com/#erstinformation-en',
      },
      {
        country: 'ES',
        url: 'https://legal.qonto.com/#pre-contractual-information-insurance-contract-es',
      },
    ],
  },
  'investment-program': {
    type: 'country',
    links: [
      {
        country: 'DE',
        url: 'https://legal.qonto.com/#investment-program-de',
      },
    ],
  },
  'kyc-partner-terms': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://www.fourthline.com/terms-and-conditions',
      },
    ],
  },
  'kyc-partner': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://fourthline.com',
      },
    ],
  },
  'legacy-capital-deposit-terms': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://legal.qonto.com/en#template-k2n8yixgp',
      },
      {
        language: 'fr',
        url: 'https://legal.qonto.com/fr#template-zgairaxx6',
      },
    ],
  },
  'mirror-card-venice-festival-terms': {
    type: 'country',
    links: [
      {
        country: 'DE',
        url: 'https://legal.qonto.com/#mirror-card-gewinnspiel',
      },
      {
        country: 'FR',
        url: 'https://legal.qonto.com/#carte-miroir-festival-de-venise-tirage-au-sort',
      },
    ],
  },
  'mollie-privacy-policy': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://www.mollie.com/gb/legal/privacy',
      },
      {
        language: 'fr',
        url: 'https://www.mollie.com/fr/legal/privacy',
      },
      {
        language: 'de',
        url: 'https://www.mollie.com/de/legal/privacy',
      },
      {
        language: 'it',
        url: 'https://www.mollie.com/it/legal/privacy',
      },
    ],
  },
  'nrc-tax-payment-spain': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://legal.qonto.com/#tax-payment-spain-en',
      },
      {
        language: 'es',
        url: 'https://legal.qonto.com/#tax-payment-spain-es',
      },
    ],
  },
  'payment-services-framework-agreement': {
    type: 'language',
    links: [
      {
        language: 'es',
        url: 'https://legal.qonto.com/es#politica-privacidad',
      },
    ],
  },
  'pos-pre-contract-spain': {
    type: 'language',
    links: [
      {
        language: 'es',
        url: 'https://legal.qonto.com/es#ttp-folletoinformativo',
      },
    ],
  },
  'pos-terms-generic': {
    type: 'language',
    links: [
      {
        language: 'fr',
        url: 'https://legal.qonto.com/#cgv-pos-fr',
      },
    ],
  },
  'pos-terms-spain': {
    type: 'language',
    links: [
      {
        language: 'es',
        url: 'https://legal.qonto.com/es#contrato-ttp',
      },
    ],
  },
  'pricing-grid': {
    type: 'country',
    links: [
      {
        country: 'DE',
        url: 'https://legal.qonto.com/de#template-7avka33ec',
      },
      {
        country: 'FR',
        url: 'https://legal.qonto.com/fr#template-k0dnmvpv0',
      },
      {
        country: 'NL',
        url: 'https://legal.qonto.com/nl#pricing-nl-en',
      },
      {
        country: 'PT',
        url: 'https://legal.qonto.com/pt#pricing-pt-en',
      },
      {
        country: 'IT',
        url: 'https://legal.qonto.com/it#template-c0iteozwa',
      },
      {
        country: 'ES',
        url: 'https://legal.qonto.com/es#contrato-marco-serviciosdepago',
      },
      {
        country: 'BE',
        url: 'https://legal.qonto.com/be#pricing-be-en',
      },
      {
        country: 'AT',
        url: 'https://legal.qonto.com/at#pricing-at-en',
      },
    ],
  },
  'pricing-plans-comparison-registration': {
    type: 'country',
    links: [
      {
        country: 'FR',
        url: 'https://legal.qonto.com/fr#template-k0dnmvpv0',
      },
      {
        country: 'DE',
        url: 'https://legal.qonto.com/de#template-7avka33ec',
      },
      {
        country: 'ES',
        url: 'https://legal.qonto.com/es#template-d8zaxdmob',
      },
      {
        country: 'IT',
        url: 'https://legal.qonto.com/it#template-c0iteozwa',
      },
      {
        country: 'AT',
        url: 'https://legal.qonto.com/#pricing-english-at-nl-be-pt',
      },
      {
        country: 'NL',
        url: 'https://legal.qonto.com/#pricing-english-at-nl-be-pt',
      },
      {
        country: 'BE',
        url: 'https://legal.qonto.com/#pricing-english-at-nl-be-pt',
      },
      {
        country: 'PT',
        url: 'https://legal.qonto.com/#pricing-english-at-nl-be-pt',
      },
    ],
  },
  'pricing-plans-comparison-subscription': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://legal.qonto.com/en#template-n-qjlga4x',
      },
      {
        language: 'fr',
        url: 'https://legal.qonto.com/fr#template-k0dnmvpv0',
      },
      {
        language: 'de',
        url: 'https://legal.qonto.com/de#template-7avka33ec',
      },
      {
        language: 'es',
        url: 'https://legal.qonto.com/es#template-d8zaxdmob',
      },
      {
        language: 'it',
        url: 'https://legal.qonto.com/it#template-xjh7afg6v',
      },
      {
        language: 'nl',
        url: 'https://legal.qonto.com/nl#template-n-qjlga4x',
      },
      {
        language: 'pt',
        url: 'https://legal.qonto.com/pt#template-n-qjlga4x',
      },
    ],
  },
  'qonto-invoicing-terms': {
    type: 'language',
    links: [
      {
        language: 'fr',
        url: 'https://legal.qonto.com/#qonto-facturation-fr-fr',
      },
    ],
  },
  'qonto-privacy-policy': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://legal.qonto.com/en#template-6uiwuhdde',
      },
      {
        language: 'fr',
        url: 'https://legal.qonto.com/fr#template-6lrfpw-ck',
      },
      {
        language: 'de',
        url: 'https://legal.qonto.com/de#template-0nkd87err',
      },
      {
        language: 'nl',
        url: 'https://legal.qonto.com/nl#template-6uiwuhdde',
      },
      {
        language: 'es',
        url: 'https://legal.qonto.com/es#template-jdjkefjao',
      },
      {
        language: 'it',
        url: 'https://legal.qonto.com/it#template-wf2wgdzgo',
      },
      {
        language: 'pt',
        url: 'https://legal.qonto.com/pt#template-6uiwuhdde',
      },
    ],
  },
  'registration-terms': {
    type: 'country',
    links: [
      {
        country: 'FR',
        url: 'https://legal.qonto.com/fr#template-soeeahmte',
      },
      {
        country: 'DE',
        url: 'https://legal.qonto.com/#de-terms-v15',
      },
      {
        country: 'ES',
        url: 'https://legal.qonto.com/es#template-6b7sl-kba',
      },
      {
        country: 'IT',
        url: 'https://legal.qonto.com/it#template-soeeahmte',
      },
      {
        country: 'AT',
        url: 'https://legal.qonto.com/#template-goi-lzmgb',
      },
      {
        country: 'NL',
        url: 'https://legal.qonto.com/#template-soeeahmte',
      },
      {
        country: 'BE',
        url: 'https://legal.qonto.com/#template-soeeahmte',
      },
      {
        country: 'PT',
        url: 'https://legal.qonto.com/#template-soeeahmte',
      },
    ],
  },
  'restricted-activities': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://legal.qonto.com/en#template-uoa8xux5p',
      },
      {
        language: 'fr',
        url: 'https://legal.qonto.com/fr#template-k-joosxaw',
      },
      {
        language: 'de',
        url: 'https://legal.qonto.com/de#template-xv0krm2iw',
      },
      {
        language: 'es',
        url: 'https://legal.qonto.com/es#template-cdkrhs5co',
      },
      {
        language: 'it',
        url: 'https://legal.qonto.com/it#template-swokqwuvs',
      },
    ],
  },
  'subscription-change-terms-it': {
    type: 'language',
    links: [
      {
        language: 'it',
        url: 'https://legal.qonto.com/it#template-aw5epljsu',
      },
    ],
  },
  'tap-to-pay-terms': {
    type: 'language',
    links: [
      {
        language: 'en',
        url: 'https://legal.qonto.com/#ttp-en',
      },
      {
        language: 'fr',
        url: 'https://legal.qonto.com/#ttp-fr',
      },
      {
        language: 'it',
        url: 'https://legal.qonto.com/#ttp-it',
      },
      {
        language: 'es',
        url: 'https://legal.qonto.com/#ttp-esp',
      },
      {
        language: 'nl',
        url: 'https://legal.qonto.com/#ttp-nl',
      },
      {
        language: 'de',
        url: 'https://legal.qonto.com/#ttp-de',
      },
      {
        language: 'pt',
        url: 'https://legal.qonto.com/#ttp-pt',
      },
    ],
  },
} satisfies Record<string, TermsAndConditionsEntry>;

export type TNCKey = keyof typeof TERMS_AND_CONDITIONS;
